import { BrowserRouter } from "react-router-dom";
import "./App.css";
import MainPage from "./MainPage";
import { EventProvider } from "./context/EventContext";
import { LoaderProvider } from "./context/LoaderContext";
import { EventBannerProvider } from "./context/EventBannerContext";
import { ShowMenuProvider } from "./context/ShowMenuContext";
import { MemberBannerProvider } from "./context/MemberContext";
import { GalleryBannerProvider } from "./context/GalleryBannerContext";
import { GalleryImageProvider } from "./context/GalleryImageContext";
import { CompanyDetailsProvider } from "./context/CompanyDetailsContext";
import { UserDataProvider } from "./context/UserDataContext";
import { ShowUserMenuProvider } from "./context/ShowUserMenuContext";
import { useToast } from "./hooks/useToast";

function App() {
  return (
    <>
      <UserDataProvider>
        <CompanyDetailsProvider>
          <GalleryImageProvider>
            <GalleryBannerProvider>
              <MemberBannerProvider>
                <ShowUserMenuProvider>
                  <ShowMenuProvider>
                    <EventBannerProvider>
                      <LoaderProvider>
                        <EventProvider>
                          <BrowserRouter>
                            <MainPage />
                          </BrowserRouter>
                        </EventProvider>
                      </LoaderProvider>
                    </EventBannerProvider>
                  </ShowMenuProvider>
                </ShowUserMenuProvider>
              </MemberBannerProvider>
            </GalleryBannerProvider>
          </GalleryImageProvider>
        </CompanyDetailsProvider>
      </UserDataProvider>
      {useToast()}
    </>
  );
}

export default App;
